import Vue from 'vue';

export const batchUpdateListingService = {
  retrieveBatchUpdateResults(params) {
    return Vue.axios
      .post('/search/advanced-search', {
        ...params
      })
      .then(response => response.data);
  }
};
